import type { InjectionKey } from 'vue';
import type {
  CatalogueItem,
  CatalogueItemDetail,
  ChildItemData,
} from '@/models/Catalogue';

export interface CatalogueItemActions {
  viewItem: (item: CatalogueItem) => void;
  editItem: (item: CatalogueItem) => void;
  deleteItem: (item: CatalogueItem) => void;
  duplicateItem: (item: CatalogueItem) => void;
  createRevision: (item: CatalogueItem) => void;
  addToBom: (item: CatalogueItem) => void;
  openChild: (uuid: string) => void;
  requestPromotion: (item: CatalogueItemDetail) => void;
  cancelPromotion: (item: CatalogueItemDetail) => void;
  uploadImage: (file: File) => void;
  deleteImage: (imageUrl: string) => void;
  uploadFile: (file: File) => void;
  deleteFile: (fileName: string) => void;
  addChild: (childData: ChildItemData) => void;
  removeChild: (childUuid: string) => void;
  updateChildQuantity: (childUuid: string, quantity: number) => void;
}

export const CatalogueItemActionsKey: InjectionKey<CatalogueItemActions> =
  Symbol('CatalogueItemActions');
